const toppings = [
    {
      item:"None",
      id: 1
    },
    {
      item:"Mushroom",
      id: 2
    },
    {
      item:"Onions",
      id: 3
    },
    {
      item:"Ham",
      id: 4
    },
    {
      item:"Oregano",
      id: 5
    },
    {
      item:"Sausage",
      id: 6
    },
    {
      item:"Bell Pepper Strips",
      id: 7
    },
    {
      item:"Olives",
      id: 8
    },
    {
      item:"Chilli Flakes",
      id: 9
    },
    {
      item:"Cheese",
      id: 10
    },
    
  ];
  export default toppings;